
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pptx-to-flashcards",
      function () {
        return require("private-next-pages/pptx-to-flashcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pptx-to-flashcards"])
      });
    }
  